<template>
  <div class="widget-card-content">
    <h2 class="content-title">{{title}}</h2>

    <div class="widget-card-articles" >
      <p v-for="(text, index) in articles"
         :key="index"
      >
        {{text}}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WidgetCardRecommendedTraining',
  props: {
    title: {
      type: String,
      default: null,
    },
    articles: {
      type: Array,
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-articles {
  display: flex;
  flex-direction: column;
  margin: 25px -5px -5px -5px;
  @media (max-width 1170px) {
    margin-top: 34px;
  }
  @media (max-width 747px) {
    margin-top: 32px;
  }
  @media (max-width 480px) {
    margin-top: 12px;
  }
  & p {
    margin: 5px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
  }
}
</style>
